<template>
  <router-link
      class="link"
      :to="{path: '/simcard_profile/' + traffic_item.simcard_profile_id}"
  >
    <tr class="action_item">
      <td :data-label="translate('simcard_profile.traffic_list.mno')">
        {{ traffic_item.mno }}
      </td>
      <td :data-label="translate('simcard_profile.traffic_list.oper_account')">
        {{ traffic_item.oper_account }}
      </td>
      <td :data-label="translate('simcard_profile.traffic_list.iccid')">
        <router-link :to="{path: '/device_list?&universal_search=' + traffic_item.iccid}" @click.stop.prevent="">
          {{ traffic_item.iccid }}
        </router-link>
        <span v-if="traffic_item.iccid" class="mdi mdi-content-copy" @click.stop.prevent="copy(traffic_item.iccid)" />
      </td>
      <td :data-label="translate('simcard_profile.traffic_list.sim_type')">
        {{ simcard_esim(traffic_item.sim_type) }}
      </td>
      <td :data-label="translate('simcard_profile.traffic_list.status')">
                   <span class="badge" :class="global_status_color(+traffic_item.status)">
                    {{ translate(global_status_text(+traffic_item.status)) }}
                  </span>
      </td>
      <td :data-label="translate('simcard_profile.traffic_list.tariff_name')">
        {{ traffic_item.tariff_name }}
      </td>
      <td :data-label="translate('simcard_profile.traffic_list.traffic_rest')">
        {{ traffic_item.traffic_rest }} / {{ traffic_item.traffic_limit }}
      </td>
      <td :data-label="translate('simcard_profile.traffic_list.ts_update')">
        {{ get_date(traffic_item.ts_update) }}
      </td>
    </tr>
  </router-link>
</template>

<script>
export default {
  name: 'TrafficListItem',
  props:{
    traffic_item: {
      type: [Object, Array],
      default: []
    },
  },
  methods:{
    copy(string){
      this.copy_to_clipboard(string)
      this.global_notify("info", this.translate("clipboard.value_save_buffer"));
    },
    simcard_esim(type){
      switch (type) {
        case 0: return 'sim'
        case 1: return 'esim'
      }
    },
  }
}
</script>

<style>
.action_item{

  &:hover{
    background-color: #eeeeee;
  }
}
</style>
